import './index.css';
import { useState } from 'react';
import { motion } from 'framer-motion';

export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleScroll = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <div className="bg-neutral-950 text-white min-h-screen font-sans">

      {/* Hero Section */}
      <header className="text-center py-20 px-6 bg-gradient-to-br from-neutral-900 via-black to-neutral-950">
        <motion.div
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="flex justify-center items-center gap-4 mb-6"
        >
          <img src="/logo.png" alt="Logotyp" className="w-14 h-14 md:w-16 md:h-16 relative top-[2px]" />
          <h1 className="text-5xl md:text-6xl font-extrabold text-brand">SNTeknik</h1>
        </motion.div>
        <motion.p
          className="text-neutral-400 max-w-2xl mx-auto text-lg"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          Reparationer av maskiner/motorfordon, 3D-printing, 3D-Design och utveckling av hemsidor.
        </motion.p>
      </header>

      {/* Services */}
      <section id="services" className="py-20 px-6 max-w-5xl mx-auto">
        <h2 className="text-4xl font-semibold text-brand-light mb-12 text-center">Tjänster</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {[
            { title: 'Fordon- och maskinreparation', desc: 'Felsökning och reparation av personbilar, maskiner och utrustning.' },
            { title: '3D-print på beställning', desc: 'Design och utskrift av prototyper. Även utskrifter med egen modell. Max storlek för en utskrift 256x256x256mm.' },
            { title: 'Webbutveckling', desc: 'Tillverkning av hemsidor på beställning främst inriktad på funktionalitet över design.' },
          ].map(({ title, desc }, i) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              viewport={{ once: true }}
              className="bg-neutral-900 rounded-2xl p-6 shadow-md border border-neutral-800 hover:border-brand-dark hover:shadow-brand-dark/30 transition duration-300"
            >
              <h3 className="text-lg font-semibold text-white mb-2">{title}</h3>
              <p className="text-neutral-400 text-sm leading-relaxed">{desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Pricing */}
      <section id="pricing" className="py-20 px-6 bg-neutral-900">
        <h2 className="text-4xl font-semibold text-brand-light mb-12 text-center">Priser</h2>
        <div className="flex flex-col md:flex-row justify-center gap-10">
        <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="bg-neutral-950 border border-neutral-800 hover:border-brand-dark rounded-xl p-6 w-full max-w-sm shadow-md transition"
            >
            <h3 className="text-lg font-semibold text-white mb-3">Offert</h3>
            <p className="text-neutral-400 text-sm leading-relaxed">
                Kontakta mig för priser. Alla priser exkl. moms. Betalning sker endast via faktura eller Swish.
            </p>
        </motion.div>

        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="py-20 px-6 max-w-3xl mx-auto">
        <h2 className="text-4xl font-semibold text-brand-light mb-8 text-center">Kontakt</h2>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="bg-neutral-900 p-6 rounded-xl shadow-sm space-y-4 text-neutral-300 border border-neutral-800"
        >
          <p><strong>Namn:</strong> Samuel Nordvall</p>
          <p><strong>Telefon:</strong> 072-702 39 68</p>
          <p><strong>E-post:</strong> samuel@snteknik.se</p>
        </motion.div>
      </section>

      <footer className="text-center py-6 text-sm text-neutral-600">
        &copy; {new Date().getFullYear()} SNTeknik. Alla rättigheter förbehållna.
      </footer>
    </div>
  );
}
